import { useParams, useNavigate } from "react-router-dom";
import { DeliveryNoteDetailPage as DeliveryNoteDetailPageView } from "@/components/DeliveryNoteDetailPage";

export function DeliveryNoteDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  if (!id) return null;

  return (
    <DeliveryNoteDetailPageView
      deliveryNoteId={id}
      onBack={() => navigate("/delivery-notes")}
      onMatchClick={(billId) => navigate(`/bills/${billId}/match`)}
      onSupplierClick={(supplierId) => navigate(`/suppliers/${supplierId}`)}
      onPurchaseOrderClick={(purchaseOrderId) => navigate(`/purchase-orders/${purchaseOrderId}`)}
    />
  );
}
